window.onload = function() {
  // Function to insert the new HTML content
  function insertContent() {
    var myDivs = document.querySelectorAll('.basic');

    // Check if the divs exist
    if (myDivs.length > 0) {
      myDivs.forEach(function(myDiv) {
        // Avoid duplicate content insertion
        if (!myDiv.querySelector('iframe')) {
          // Create a new div element and set its innerHTML
          var newDiv = document.createElement('div');
          newDiv.innerHTML = '<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/964623171?h=18d5a3f295&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Style guide"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>';

          // Append the new div element to the existing div
          myDiv.appendChild(newDiv);
        }
      });
      return true;
    }
    return false;
  }

  // Create a MutationObserver to monitor DOM changes
  var observer = new MutationObserver(function(mutations) {
    insertContent();  // Check for the target element whenever there are DOM changes
  });

  // Start observing the document body for added nodes
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial check in case the element is already loaded
  if (!insertContent()) {
    // Second check after a short delay if the initial check fails
    setTimeout(function() {
      insertContent();
    }, 1000); // Adjust the timeout as necessary (1000ms = 1s)
  }
};
